<template>
  <!-- <b-nav-item-dropdown -->
  <b-dropdown
    class="dropdown-user"
    v-ripple.400="'rgba(30, 30, 30, 0.15)'"
    variant="flat-primary"
    right
  >
    <template #button-content class="btn-user">
      <div class="user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.username || userData.email }}
        </p>
        <span class="user-profile">{{ getProfile }}</span>
      </div>
      <b-avatar
        v-if="!userData.avatar"
        size="0"
        :src="getUserAvatar"
        variant="light-primary"
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!userData.fullName" icon="UserIcon" size="18" class="iconuser" />
      </b-avatar>

      
    </template>

    <!-- <b-dropdown-item :to="{ name: 'admin' }"> -->
    <b-dropdown-item @click="openClientAccessPage" v-if="isAdmin || isMarketing">
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Client_Access')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openAdminPage" v-if="isAdmin">
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Admin')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openAttendancePage" v-if="isAdmin || isAttendance">
      <feather-icon size="16" icon="MailIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Attendance')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openPublishPage" v-if="isAdmin || isPublisher || isJournalism || isConsulting || isEditor">
      <feather-icon size="16" icon="ColumnsIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Publications')}}</span>
    </b-dropdown-item>

    <b-dropdown-item @click="openStatisticsPage" v-if="isAdmin || isJournalism || isConsulting || isMarketing || isContract || isEditor">
      <feather-icon size="16" icon="TrelloIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Reports')}}</span>
    </b-dropdown-item>

    <b-dropdown-item @click="openAskAnalystPage" v-if="isAdmin || isPublisher || isJournalism || isConsulting || isEditor">
      <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.AskAnalyst')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openReportTypePage" v-if="isAdmin || isConsulting || isEditor">
      <feather-icon size="16" icon="ArchiveIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Report_Type')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openReportTypeGroupsPage" v-if="isAdmin || isPublisher || isJournalism || isConsulting || isEditor">
      <feather-icon size="16" icon="ArchiveIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.ReportTypeGroups')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openAuthTokenPage" v-if="isAdmin || isMarketing">
      <feather-icon size="16" icon="KeyIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Auth_Token')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openAuditlogPage" v-if="isAdmin || isCommercial || isMarketing">
      <feather-icon size="16" icon="FolderIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Auditlog')}}</span>
    </b-dropdown-item>
    <b-dropdown-item @click="openLeadsPage" v-if="isAdmin || isContract || isMarketing">
      <feather-icon size="16" icon="FolderIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Leads')}}</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item @click="openLeadsPage" v-if="isAdmin || isMarketing">
      <feather-icon size="16" icon="FolderIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.AuthToken')}}</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item @click="openContentPrivateCustomPage" v-if="isAdmin || isMarketing">
      <feather-icon size="16" icon="EditIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.ContentCustom')}}</span>
    </b-dropdown-item> -->

    <b-dropdown-divider />
    <!-- <b-dropdown-item :to="{ name: 'pages-account-setting' }"> -->
    <b-dropdown-item @click="openUserAccountPage">
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.My_Account')}}</span>
    </b-dropdown-item>
    

    <b-dropdown-item @click="changeTheme">
      <feather-icon size="14" :icon="getCurrentThemeIcon" class="mr-50" />
      <span>{{ getCurrentThemeName }}</span>
    </b-dropdown-item>
    

    <b-dropdown-divider />

    <b-dropdown-item @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>{{$t('DROPDOWN_USER.Logout')}}</span>
    </b-dropdown-item>

    <!-- </b-nav-item-dropdown> -->
  </b-dropdown>
</template>

<script>
import {
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BDropdown,
} from "bootstrap-vue";
import authService from "@/providers/authService";
import AppConstants from "@/appConstants";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    // BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    getProfile() {
      if (!this.userData) {
        return '';
      }
      switch (this.userData.profile) {
        case AppConstants.USER_PROFILE.ADMIN:
          return this.$t('PROFILE.Admin');
        case AppConstants.USER_PROFILE.PUBLISHER:
          return this.$t('PROFILE.Publisher');
        case AppConstants.USER_PROFILE.JOURNALISM:
          return this.$t('PROFILE.Journalism');
        case AppConstants.USER_PROFILE.ATTENDANCE:
          return this.$t('PROFILE.Attendance');
        case AppConstants.USER_PROFILE.CONTRACT:
          return this.$t('PROFILE.Contract');
        case AppConstants.USER_PROFILE.CONSULTING:
          return this.$t('PROFILE.Consulting');
        case AppConstants.USER_PROFILE.MARKETING:
          return this.$t('PROFILE.Marketing');
        case AppConstants.USER_PROFILE.COMMERCIAL:
          return this.$t('PROFILE.Commercial');
        case AppConstants.USER_PROFILE.EDITOR:
          return this.$t('PROFILE.Editor');
      }

      return '';
    },
    isAdmin() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.ADMIN) {
          return true;
        }
      }
      return false;
    },
    isAttendance() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.ATTENDANCE) {
          return true;
        }
      }
      return false;
    },
    isContract() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.CONTRACT) {
          return true;
        }
      }
      return false;
    },
    isPublisher() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.PUBLISHER) {
          return true;
        }
      }
      return false;
    },
    isJournalism() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.JOURNALISM) {
          return true;
        }
      }
      return false;
    },
    isConsulting() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.CONSULTING) {
          return true;
        }
      }
      return false;
    },
    isMarketing() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.MARKETING) {
          return true;
        }
      }
      return false;
    },
    isCommercial() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.COMMERCIAL) {
          return true;
        }
      }
      return false;
    },
    isEditor() {
      if (this.userData) {
        if (this.userData.profile == AppConstants.USER_PROFILE.EDITOR) {
          return true;
        }
      }
      return false;
    },
    userData() {
      return this.$store.state.auth.currentUser || {};
    },
    getCurrentThemeIcon() {
      if (this.userData.theme == AppConstants.THEME_DARK) {
        return "SunIcon";
      }
      return "MoonIcon";
    },
    getCurrentThemeName() {
      if (this.userData.theme == AppConstants.THEME_DARK) {
        return this.$t('DROPDOWN_USER.Theme_Light');
      }
      return this.$t('DROPDOWN_USER.Theme_Dark');
    },
    getUserAvatar() {
      if (!this.userData.avatar) {
        return require("@/assets/images/avatars/13-small.png");
      }
      return this.userData.avatar;
    },
  },
  methods: {
    openAdminPage() {
      this.$router.push({name: 'admin'});
    },
    openClientAccessPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_CLIENT_ACCESS});
    },
    openAttendancePage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ATTENDANCE});
    },
    openPublishPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_MANAGE_NEWS});
    },
    openStatisticsPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_STATISTICS});
    },
    openAskAnalystPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ASK_ANALYST});
    },
    openAuthTokenPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_AUTH_TOKEN});
    },
    openAuditlogPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_AUDITLOG});
    },
    openReportTypePage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_REPORT_TYPE});
    },
    openReportTypeGroupsPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_REPORT_TYPE_GROUPS});
    },
    openContentPrivateCustomPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_CONTENT_PRIVATE_CONF});
    },
    openLeadsPage() {
      this.$router.push({path: AppConstants.NAVIGATION_PAGE_ADM_LEADS});
    },
    openUserAccountPage() {
      this.$emit('open-user-modal');
    },
    logout() {
      authService.logout();
    },
    changeTheme() {
      if (this.userData.theme == AppConstants.THEME_DARK) {
        this.$store.dispatch("auth/updateTheme", AppConstants.THEME_LIGHT);
      } else {
        this.$store.dispatch("auth/updateTheme", AppConstants.THEME_DARK);
      }
      setTimeout(() => {
        this.$forceUpdate();
      }, 500);
    },
  },
};
</script>
